import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import GetConsentByHandleResponse from '../../../../../Models/Response/Consent/GetConsentByHandle';
import { getConsentByConsentHandle } from '../../../../../Services/ConsentServices/ConsentService';
import { Routes } from '../../../../../Utils/Constants/routes';
import CommonConsentDetails from '../../CommonConsentDetails';
import '../index.css';

interface IRejectExpireConsentProps {
  consentUniqueId: string;
  createdOrUpdatedOn: string;
  type: string;
}

const RejectedExpiredConsent: React.FC<IRejectExpireConsentProps> = ({
  consentUniqueId,
  createdOrUpdatedOn,
  type,
}) => {
  const history = useHistory();
  const [consentDetailsByHandle, setConsentDetailsByHandle] = useState({
    Customer: { id: '' },
    DataConsumer: { dataConsumerType: '', id: '' },
    DataFilter: [{ type: '', operator: '', value: '' }],
    DataLife: { unit: '', value: 0 },
    FIDataRange: { from: '', to: '' },
    Frequency: { unit: '', value: 0 },
    Purpose: { category: { type: '' }, code: '', refUri: '', text: '' },
    consentExpiry: '',
    consentMode: '',
    consentStart: '',
    consentTypes: [''],
    fetchType: '',
    fiTypes: [''],
  });

  useEffect(() => {
    getConsentByConsentHandle(consentUniqueId)
      .then((res) => res.data)
      .then((res: GetConsentByHandleResponse) => setConsentDetailsByHandle(res))
      .catch(() => history.replace(Routes.consent));
  }, [consentUniqueId, history]);

  return (
    <>
      <CommonConsentDetails
        createdOrUpdatedOn={createdOrUpdatedOn}
        type={type}
        consentByUniqueIdDetails={consentDetailsByHandle}
      />
    </>
  );
};

export default RejectedExpiredConsent;
